import Navbar from "../components/navigation/Navbar";
import { Download, ImagePlay, Import, Info } from "lucide-react";
import Button from "../components/ui/Button";
import { useNavigate } from "react-router-dom";


export default function Support() {
    const navigate = useNavigate();
    const go_to_page = () => {
        window.open("https://xroadz.ai/",'_blank','noopener,noreferrer');
    }

    return (
        <>
            <Navbar />
            <div className="min-h-screen bg-gray-50 pt-14">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6">
                        <div className="p-6 border-b border-gray-200">
                            <h1 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                                <Info className="text-blue-600 mr-2" size={24} />
                                Support Information
                            </h1>
                            <div className="p-6">
                                <div className="space-y-3">
                                    <p className="text-gray-700 leading-relaxed mb-4">
                                        For any inquiries or assistance, please direct your
                                        communication to your designated XRoadZ point of contact.
                                        They are best positioned to address your request promptly
                                        and accurately.
                                    </p>
                                    <p className="text-gray-700 leading-relaxed">
                                        We appreciate your cooperation and look forward to assisting
                                        you through the appropriate channels.
                                    </p>
                                    <Button
                                        children={"Go to XRoadz.ai"}
                                        onClick={go_to_page}
                                        variant="outline"
                                    // class="flex justify-center items-center flex-grow-0 flex-shrink-0  h-11 relative gap-2.5 px-3 py-2 rounded border-[1.5px] border-[#d0d5dd]"
                                    ></Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
